export const MATERIAL_TYPE = 'SVCITEMTYPE_PART';
